import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="bg-ink min-h-screen flex items-center justify-center">
        <Loader2 className="animate-spin text-[color:var(--cyan)]" size={28} />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/join" replace state={{ from: location.pathname }} />;
  }
  return children;
};
